import {
    SET_DAY_RANGE,
    SET_SELECTED_DAYS,
    SET_TRACKS,
    SET_TRACK_ROW,
    OPEN_ADD_EVENT_MODAL,
    CLOSE_ADD_EVENT_MODAL,
    OPEN_EDIT_EVENT_MODAL,
    CLOSE_EDIT_EVENT_MODAL,
    OPEN_DELETE_TRACK_MODAL,
    CLOSE_DELETE_TRACK_MODAL,
    OPEN_ADD_PARENT_TRACK_MODAL,
    CLOSE_ADD_PARENT_TRACK_MODAL,
    OPEN_ADD_CHILD_TRACK_MODAL,
    CLOSE_ADD_CHILD_TRACK_MODAL,
    CREATE_PARENT_TRACK,
    DELETE_TASK,
    DELETE_TRACK,
    SET_DELETING_TRACK,
    SET_CREATE_CHILD_TRACK_PARENT,
    CREATE_CHILD_TRACK,
    OPEN_EDIT_TRACK_MODAL,
    CLOSE_EDIT_TRACK_MODAL,
    SET_EDITING_TRACK,
    EDIT_TRACK,
    GET_JOB_PACKS,
    GET_MACHINES,
    GET_USERS,
    GET_EQUIPMENT,
    SET_FOCUSSED_EVENT,
    SET_CLICKED_TIME_BLOCK,
    SET_FOCUSSED_EVENT_INDICES,
    SET_AGENDA_ITEM_DRAGGING,
    SET_AGENDA_ITEM_POSITION,
    SET_WEEK_COUNT,
    SET_TRACK_HEIGHT,
    GET_UI_STATE,
    SET_UI_STATE,
    SET_PARENT_TRACK_OPEN
} from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import moment from "moment";

export const convertTaskToEvent = (startDate, task) => {
    const rosterStartDate = moment(startDate);
    const taskStartDate = moment(task.start_date, "DD/MM/YYYY");
    const taskEndDate = moment(task.end_date, "DD/MM/YYYY");

    const startDifference = taskStartDate.diff(rosterStartDate, "days");
    const endDifference = taskEndDate.diff(rosterStartDate, "days");

    return {
        start: startDifference,
        end: endDifference + 1,
        id: task.id,
        row: task.row,
        name: task.name,
        jobpack_key: task.jobpack_key,
        assigned_task_key: task.assigned_task_key,
        resource_key: task.resource_key,
        type: task.type,
        color: task.color
    };
};

export const convertEventToTask = (startDate, event) => {
    const rosterStartDate = moment(startDate);
    const rosterStartDate2 = moment(startDate);

    const taskStartDate = rosterStartDate
        .add(event.start, "days")
        .format("DD/MM/YYYY")
        .toString();

    const taskEndDate = rosterStartDate2
        .add(event.end - 1, "days")
        .format("DD/MM/YYYY")
        .toString();

    return {
        start_date: taskStartDate,
        end_date: taskEndDate,
        name: event.name,
        id: event.id,
        row: event.row,
        jobpack_key: event.jobpack_key,
        assigned_task_key: event.assigned_task_key,
        resource_key: event.resource_key,
        type: event.type,
        color: event.color
    };
};

export const getEvents = (start, end) => {
    return dispatch => {
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                // dispatch({ type: GET_USERS.FAIL });
            } else {
                firebase
                    .database()
                    .ref(`/dashboard/roster/tracks`)
                    .on("value", snapshot => {
                        if (typeof snapshot.val() !== "undefined") {
                            const tracks = snapshot.val();
                            // const result = arrangeTracksInit(start, tracks);
                            dispatch({
                                type: SET_TRACKS,
                                payload: tracks
                            });
                        } else {
                            // dispatch({ type: GET_USERS.FAIL });
                        }
                    });
            }
        });
    };
};

export const setEventTimeAction = (
    event,
    eventStart,
    eventEnd,
    parentTrackIndex,
    childTrackIndex,
    startDay,
    tracks,
    row
) => {
    return dispatch => {
        event.start = eventStart;
        event.end = eventEnd;
        event.row = row;
        const task = convertEventToTask(startDay, event);
        let firebasePath = "";
        if (childTrackIndex === false) {
            tracks[parentTrackIndex].tasks[event.index] = task;
            firebasePath = `/dashboard/roster/tracks/${parentTrackIndex}/tasks/${event.index}`;
        } else {
            tracks[parentTrackIndex].children[childTrackIndex].tasks[event.index] = task;
            firebasePath = `/dashboard/roster/tracks/${parentTrackIndex}/children/${childTrackIndex}/tasks/${
                event.index
            }`;
        }

        dispatch({
            type: SET_TRACK_ROW,
            payload: tracks
        });

        if (!task.jobpack_key || !task.start_date || !task.end_date) {
            return;
        }

        firebase
            .database()
            .ref(firebasePath)
            .set(task);

        if (task.resource_key !== false) {
            const assignedTask = {
                subject_child: task.jobpack_key,
                subject_name: "job_packs",
                start_date: task.start_date,
                end_date: task.end_date
            };
            firebase
                .database()
                .ref(`${task.resource_key}/assigned_tasks/${task.assigned_task_key}`)
                .set(assignedTask);
        }
    };
};

export const editEvent = (
    event,
    startDate,
    parentTrackIndex,
    childTrackIndex,
    eventIndex,
    tracks
) => {
    return dispatch => {
        const task = convertEventToTask(startDate, event);

        if (childTrackIndex === false) {
            tracks[parentTrackIndex].tasks[eventIndex] = task;
        } else {
            tracks[parentTrackIndex].children[childTrackIndex].tasks[eventIndex] = task;
        }
        dispatch({
            type: SET_TRACK_ROW,
            payload: tracks
        });
        firebase
            .database()
            .ref(`/dashboard/roster/tracks`)
            .set(tracks);
    };
};

export const deleteEvent = (event, parentTrackIndex, childTrackIndex, eventIndex, tracks) => {
    return dispatch => {
        if (childTrackIndex === false) {
            tracks[parentTrackIndex].tasks.splice(eventIndex, 1);
        } else {
            tracks[parentTrackIndex].children[childTrackIndex].tasks.splice(eventIndex, 1);
        }
        dispatch({
            type: SET_TRACK_ROW,
            payload: tracks
        });
        firebase
            .database()
            .ref(`/dashboard/roster/tracks`)
            .set(tracks);

        if (event.resource_key !== false) {
            firebase
                .database()
                .ref(`${event.resource_key}/assigned_tasks/${event.assigned_task_key}`)
                .remove();
        }
    };
};

export const setFocussedEventIndices = (parentTrackIndex, childTrackIndex, eventIndex) => {
    return dispatch => {
        dispatch({
            type: SET_FOCUSSED_EVENT_INDICES,
            payload: { parentTrackIndex, childTrackIndex, eventIndex }
        });
    };
};

export const setDayRange = (start, end, initial = false) => {
    return dispatch => {
        dispatch({
            type: SET_DAY_RANGE,
            payload: { start, end }
        });

        if (initial === true) {
            dispatch(getEvents(start, end));
        }
    };
};

export const setSelectedDays = days => {
    return dispatch => {
        dispatch({
            type: SET_SELECTED_DAYS,
            payload: days
        });
    };
};

export const undo = () => {
    return dispatch => {
        dispatch({
            type: "UNDO"
        });
    };
};

export const redo = () => {
    return dispatch => {
        dispatch({
            type: "REDO"
        });
    };
};

export const openAddEventModal = timeBlock => {
    return dispatch => {
        dispatch({
            type: OPEN_ADD_EVENT_MODAL,
            payload: timeBlock
        });
    };
};

export const closeAddEventModal = () => {
    return dispatch => {
        dispatch({
            type: CLOSE_ADD_EVENT_MODAL
        });
    };
};

export const openEditEventModal = event => {
    return dispatch => {
        dispatch({
            type: OPEN_EDIT_EVENT_MODAL
        });
    };
};

export const closeEditEventModal = () => {
    return dispatch => {
        dispatch({
            type: CLOSE_EDIT_EVENT_MODAL
        });
    };
};

export const openDeleteTrackModal = event => {
    return dispatch => {
        dispatch({
            type: OPEN_DELETE_TRACK_MODAL
        });
    };
};

export const closeDeleteTrackModal = () => {
    return dispatch => {
        dispatch({
            type: CLOSE_DELETE_TRACK_MODAL
        });
    };
};

export const openEditTrackModal = event => {
    return dispatch => {
        dispatch({
            type: OPEN_EDIT_TRACK_MODAL
        });
    };
};

export const closeEditTrackModal = () => {
    return dispatch => {
        dispatch({
            type: CLOSE_EDIT_TRACK_MODAL
        });
    };
};

export const openAddParentTrackModal = () => {
    return dispatch => {
        dispatch({
            type: OPEN_ADD_PARENT_TRACK_MODAL
        });
    };
};

export const closeAddParentTrackModal = () => {
    return dispatch => {
        dispatch({
            type: CLOSE_ADD_PARENT_TRACK_MODAL
        });
    };
};

export const openEditParentTrackModal = (parentTrackIndex, childTrackIndex) => {
    return dispatch => {
        dispatch({
            type: OPEN_EDIT_TRACK_MODAL,
            payload: { parentTrackIndex, childTrackIndex }
        });
    };
};

export const closeEditParentTrackModal = () => {
    return dispatch => {
        dispatch({
            type: CLOSE_EDIT_TRACK_MODAL
        });
    };
};

export const openAddChildTrackModal = () => {
    return dispatch => {
        dispatch({
            type: OPEN_ADD_CHILD_TRACK_MODAL
        });
    };
};

export const closeAddChildTrackModal = () => {
    return dispatch => {
        dispatch({
            type: CLOSE_ADD_CHILD_TRACK_MODAL
        });
    };
};

export const deleteTask = (task, tracks) => {
    return dispatch => {
        dispatch({
            type: DELETE_TASK,
            payload: tracks
        });
    };
};

export const deleteTrack = (parentTrack, childTrack, tracks) => {
    return dispatch => {
        if (childTrack === false) {
            tracks.splice(parentTrack, 1);
        } else {
            tracks[parentTrack].children.splice(childTrack, 1);
        }

        dispatch({
            type: DELETE_TRACK,
            payload: tracks
        });

        firebase
            .database()
            .ref(`/dashboard/roster/tracks`)
            .set(tracks);
    };
};

export const editTrack = (name, parentTrack, childTrack, tracks) => {
    return dispatch => {
        if (childTrack === false) {
            tracks[parentTrack].name = name;
        } else {
            tracks[parentTrack].children[childTrack].name = name;
        }

        dispatch({
            type: EDIT_TRACK,
            payload: tracks
        });

        firebase
            .database()
            .ref(`/dashboard/roster/tracks`)
            .set(tracks);
    };
};

export const setDeletingTrack = (parentTrack, childTrack) => {
    return dispatch => {
        dispatch({
            type: SET_DELETING_TRACK,
            payload: { parentTrack, childTrack }
        });
    };
};

export const setEditingTrack = (parentTrack, childTrack) => {
    return dispatch => {
        dispatch({
            type: SET_EDITING_TRACK,
            payload: { parentTrack, childTrack }
        });
    };
};

export const createParentTrack = (name, tracks) => {
    return dispatch => {
        const track = {
            children: [],
            name,
            tasks: [],
            trackCount: 1,
            type: "jobpack",
            height: 120,
            open: true
        };

        tracks.push(track);

        dispatch({
            type: CREATE_PARENT_TRACK,
            payload: tracks
        });

        firebase
            .database()
            .ref(`/dashboard/roster/tracks`)
            .set(tracks);
    };
};

export const createChildTrack = (name, type, tracks, parentTrackIndex) => {
    return dispatch => {
        const track = {
            name,
            type,
            tasks: [],
            trackCount: 1,
            height: 120
        };

        if (Array.isArray(tracks[parentTrackIndex].children) === false) {
            tracks[parentTrackIndex].children = [track];
        } else {
            tracks[parentTrackIndex].children.push(track);
        }

        dispatch({
            type: CREATE_CHILD_TRACK,
            payload: tracks
        });

        firebase
            .database()
            .ref(`/dashboard/roster/tracks`)
            .set(tracks);
    };
};

export const setCreateChildTrackParent = parent => {
    return dispatch => {
        dispatch({
            type: SET_CREATE_CHILD_TRACK_PARENT,
            payload: parent
        });
    };
};

export const createTask = (task, timeblock, tracks) => {
    return dispatch => {
        if (!task || !timeblock || !tracks) {
            return;
        }

        const parentTrackIndex = timeblock.parentTrackIndex;
        const childTrackIndex = timeblock.childTrackIndex;
        if (childTrackIndex === false && Array.isArray(tracks[parentTrackIndex].tasks) === true) {
            tracks[parentTrackIndex].tasks.push(task);
        } else if (
            childTrackIndex === false &&
            Array.isArray(tracks[parentTrackIndex].tasks) === false
        ) {
            tracks[parentTrackIndex].tasks = [task];
        } else if (
            childTrackIndex !== false &&
            Array.isArray(tracks[parentTrackIndex].children[childTrackIndex].tasks) === true
        ) {
            tracks[parentTrackIndex].children[childTrackIndex].tasks.push(task);
        } else if (
            childTrackIndex !== false &&
            Array.isArray(tracks[parentTrackIndex].children[childTrackIndex].tasks) === false
        ) {
            tracks[parentTrackIndex].children[childTrackIndex].tasks = [task];
        }

        dispatch({
            type: SET_TRACK_ROW,
            payload: tracks
        });

        firebase.auth().onAuthStateChanged(user => {
            if (
                user === null ||
                !task.jobpack_key ||
                !task.start_date ||
                !task.end_date ||
                (task.type !== "jobpack" && !task.resource_key)
            ) {
                return;
            } else {
                firebase
                    .database()
                    .ref(`/dashboard/roster/tracks`)
                    .set(tracks);

                if (task.resource_key !== false) {
                    const assignedTask = {
                        subject_child: task.jobpack_key,
                        subject_name: "job_packs",
                        start_date: task.start_date,
                        end_date: task.end_date
                    };
                    firebase
                        .database()
                        .ref(`${task.resource_key}/assigned_tasks/${task.assigned_task_key}`)
                        .set(assignedTask);
                }
            }
        });
    };
};

export const getJobpacks = () => {
    return dispatch => {
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                // dispatch({ type: GET_USERS.FAIL });
            } else {
                firebase
                    .database()
                    .ref(`/subjects/job_packs`)
                    .on("value", snapshot => {
                        if (typeof snapshot.val() !== "undefined") {
                            const jobpacks = snapshot.val();
                            dispatch({
                                type: GET_JOB_PACKS,
                                payload: jobpacks
                            });
                        } else {
                            // dispatch({ type: GET_USERS.FAIL });
                        }
                    });
            }
        });
    };
};

export const getUsers = () => {
    return dispatch => {
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                // dispatch({ type: GET_USERS.FAIL });
            } else {
                firebase
                    .database()
                    .ref(`/users`)
                    .on("value", snapshot => {
                        if (typeof snapshot.val() !== "undefined") {
                            const users = snapshot.val();
                            dispatch({
                                type: GET_USERS,
                                payload: users
                            });
                        } else {
                            // dispatch({ type: GET_USERS.FAIL });
                        }
                    });
            }
        });
    };
};

export const getEquipment = () => {
    return dispatch => {
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                // dispatch({ type: GET_USERS.FAIL });
            } else {
                firebase
                    .database()
                    .ref(`/subjects/equipment`)
                    .on("value", snapshot => {
                        if (typeof snapshot.val() !== "undefined") {
                            const equipment = snapshot.val();
                            dispatch({
                                type: GET_EQUIPMENT,
                                payload: equipment
                            });
                        } else {
                            // dispatch({ type: GET_USERS.FAIL });
                        }
                    });
            }
        });
    };
};

export const getMachines = () => {
    return dispatch => {
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                // dispatch({ type: GET_USERS.FAIL });
            } else {
                firebase
                    .database()
                    .ref(`/subjects/machines`)
                    .on("value", snapshot => {
                        if (typeof snapshot.val() !== "undefined") {
                            const machines = snapshot.val();
                            dispatch({
                                type: GET_MACHINES,
                                payload: machines
                            });
                        } else {
                            // dispatch({ type: GET_USERS.FAIL });
                        }
                    });
            }
        });
    };
};

export const setFocussedEvent = (event, hasFocus) => {
    return dispatch => {
        dispatch({
            type: SET_FOCUSSED_EVENT,
            payload: { event, hasFocus }
        });
    };
};

export const setClickedTimeBlock = index => {
    return dispatch => {
        dispatch({
            type: SET_CLICKED_TIME_BLOCK,
            payload: index
        });
    };
};

export const setAgendaItemDragging = (resource, item) => {
    return dispatch => {
        if (resource === false && item === false) {
            dispatch({
                type: SET_AGENDA_ITEM_DRAGGING,
                payload: false
            });

            dispatch({
                type: SET_AGENDA_ITEM_POSITION,
                payload: false
            });
        } else {
            dispatch({
                type: SET_AGENDA_ITEM_DRAGGING,
                payload: { resource, item }
            });
        }
    };
};

export const setAgendaItemPosition = timeBlock => {
    return dispatch => {
        dispatch({
            type: SET_AGENDA_ITEM_POSITION,
            payload: timeBlock
        });
    };
};

export const setWeekCount = count => {
    return dispatch => {
        const firebasePath = `/dashboard/roster/ui/weekCount`;

        firebase
            .database()
            .ref(firebasePath)
            .set(count);

        dispatch({
            type: SET_WEEK_COUNT,
            payload: count
        });
    };
};

export const setTrackHeight = (parentTrackIndex, childTrackIndex, height) => {
    return dispatch => {
        let firebasePath = "";

        if (childTrackIndex === false) {
            firebasePath = `/dashboard/roster/tracks/${parentTrackIndex}/height`;
        } else {
            firebasePath = `/dashboard/roster/tracks/${parentTrackIndex}/children/${childTrackIndex}/height`;
        }

        firebase
            .database()
            .ref(firebasePath)
            .set(height);

        dispatch({
            type: SET_TRACK_HEIGHT,
            payload: { parentTrackIndex, childTrackIndex, height }
        });
    };
};

export const setUIState = (key, value) => {
    return dispatch => {
        firebase
            .database()
            .ref(`/dashboard/roster/ui/${key}`)
            .set(value);

        dispatch({
            type: SET_UI_STATE,
            payload: { key, value }
        });
    };
};

export const getUIState = (key, value) => {
    return dispatch => {
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                // dispatch({ type: GET_USERS.FAIL });
            } else {
                firebase
                    .database()
                    .ref(`/dashboard/roster/ui`)
                    .on("value", snapshot => {
                        if (snapshot.val() !== null) {
                            const state = snapshot.val();
                            dispatch({
                                type: GET_UI_STATE,
                                payload: state
                            });
                        } else {
                            dispatch({
                                type: GET_UI_STATE,
                                payload: {
                                    weekCount: 2,
                                    showAgendaView: true,
                                    showDetailView: true
                                }
                            });
                            // dispatch({ type: GET_USERS.FAIL });
                        }
                    });
            }
        });
    };
};

export const setParentTrackOpen = (parentTrackIndex, state) => {
    return dispatch => {
        const firebasePath = `/dashboard/roster/tracks/${parentTrackIndex}/open`;
        firebase
            .database()
            .ref(firebasePath)
            .set(state);

        dispatch({
            type: SET_PARENT_TRACK_OPEN,
            payload: { parentTrackIndex, state }
        });
    };
};
